import { render, staticRenderFns } from "./NettoPrice.vue?vue&type=template&id=fe2c98aa&scoped=true"
import script from "./NettoPrice.vue?vue&type=script&lang=js"
export * from "./NettoPrice.vue?vue&type=script&lang=js"
import style0 from "./NettoPrice.vue?vue&type=style&index=0&id=fe2c98aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2c98aa",
  null
  
)

export default component.exports